import { CONNECTION_STATUS } from '../../config/constants';
import { useLanguage } from '../../i18n/LanguageContext.jsx';

const ConnectionStatus = ({ status }) => {
  const { t } = useLanguage();
  const configs = {
    [CONNECTION_STATUS.CONNECTED]:    { dot: 'bg-emerald-500', label: t('live') },
    [CONNECTION_STATUS.CONNECTING]:   { dot: 'bg-amber-400 animate-pulse', label: t('connecting') },
    [CONNECTION_STATUS.RECONNECTING]: { dot: 'bg-amber-400 animate-pulse', label: t('reconnecting') },
    [CONNECTION_STATUS.DISCONNECTED]: { dot: 'bg-red-500', label: t('offline') },
    [CONNECTION_STATUS.FAILED]:       { dot: 'bg-red-500', label: t('offline') },
  };

  const c = configs[status] || { dot: 'bg-zinc-400', label: '' };

  return (
    <div className="flex items-center gap-1.5">
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      <span className="text-xs text-zinc-500 dark:text-zinc-400 font-medium">{c.label}</span>
    </div>
  );
};

export default ConnectionStatus;
